import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_19: FaireProductEntity = {
  token: "driftless-studios-19",
  type: "product",
  name: "Hey There Pumpkin - Fall Candle - Soy Wax Candles",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/a462dad1c80167a035386678e308c628fc3920fa4a5e78c4b6a1a13eeebd7035.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
